"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionTypeIcon = void 0;
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType"));
const AssetIcon_1 = require("@opsbase/web-icons/icons/AssetIcon");
const CameraIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CameraIcon"));
const CheckboxIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CheckboxIcon"));
const DateTimeIcon_1 = __importDefault(require("@opsbase/web-icons/icons/DateTimeIcon"));
const FlagIcon_1 = __importDefault(require("@opsbase/web-icons/icons/FlagIcon"));
const ListRoundedIcon_1 = __importDefault(require("@opsbase/web-icons/icons/ListRoundedIcon"));
const QuestionFreeTextIcon_1 = __importDefault(require("@opsbase/web-icons/icons/QuestionFreeTextIcon"));
const QuestionInfoIcon_1 = __importDefault(require("@opsbase/web-icons/icons/QuestionInfoIcon"));
const QuestionNumberIcon_1 = __importDefault(require("@opsbase/web-icons/icons/QuestionNumberIcon"));
const QuestionRepeatIcon_1 = __importDefault(require("@opsbase/web-icons/icons/QuestionRepeatIcon"));
const QuestionSectionIcon_1 = __importDefault(require("@opsbase/web-icons/icons/QuestionSectionIcon"));
const QuestionSetIcon_1 = __importDefault(require("@opsbase/web-icons/icons/QuestionSetIcon"));
const RatingIcon_1 = __importDefault(require("@opsbase/web-icons/icons/RatingIcon"));
const SignatureIcon_1 = __importDefault(require("@opsbase/web-icons/icons/SignatureIcon"));
const StaffIcon_1 = __importDefault(require("@opsbase/web-icons/icons/StaffIcon"));
const react_1 = __importDefault(require("react"));
const QuestionTypeIcon = (_a) => {
    var { type } = _a, props = __rest(_a, ["type"]);
    switch (type) {
        case FormQuestionType_1.default.CHECK:
            return react_1.default.createElement(CheckboxIcon_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.NUMBER:
            return react_1.default.createElement(QuestionNumberIcon_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.LIST:
            return react_1.default.createElement(ListRoundedIcon_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.RATING:
            return react_1.default.createElement(RatingIcon_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.INFO:
            return react_1.default.createElement(QuestionInfoIcon_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.TEXT:
            return react_1.default.createElement(QuestionFreeTextIcon_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.DATETIME:
            return react_1.default.createElement(DateTimeIcon_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.REPETITION:
            return react_1.default.createElement(QuestionRepeatIcon_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.SECTION:
            return react_1.default.createElement(QuestionSectionIcon_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.PHOTO:
            return react_1.default.createElement(CameraIcon_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.ISSUE:
            return react_1.default.createElement(FlagIcon_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.SIGNATURE:
            return react_1.default.createElement(SignatureIcon_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.SPT:
            return react_1.default.createElement(StaffIcon_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.ASSET:
            return react_1.default.createElement(AssetIcon_1.AssetIcon, Object.assign({}, props));
        case FormQuestionType_1.default.QUESTIONSET:
            return react_1.default.createElement(QuestionSetIcon_1.default, Object.assign({}, props));
    }
};
exports.QuestionTypeIcon = QuestionTypeIcon;
exports.default = exports.QuestionTypeIcon;
